import { render } from "./OverlayInfo.vue?vue&type=template&id=2321f220"
import script from "./OverlayInfo.vue?vue&type=script&lang=js"
export * from "./OverlayInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__